import React, { useState } from "react";
// Ícones lucide-react adaptados para controle de negócios
import {
  Zap,
  Shield,
  TrendingUp,
  BarChart3,
  Gauge,
  DollarSign,
} from "lucide-react";

// Dados para os destaques (Foco: Dono/Gestor de Estacionamento)
const ownerHighlightsData = [
  {
    icon: TrendingUp,
    title: "Aumento do Ticket Médio",
    description: "Fotos atraentes, combos e upsells automáticos no cardápio.",
    ariaLabel: "Mostrar destaque Aumento do Ticket Médio",
  },
  {
    icon: Gauge,
    title: "Controle Total da Operação",
    description: "Gestão completa de pedidos, PDV, estoque e relatórios.",
    ariaLabel: "Mostrar destaque Controle Total da Operação",
  },
  {
    icon: DollarSign,
    title: "Economia Significativa",
    description:
      "Elimine taxas abusivas e reduza custos operacionais com o PDV.",
    ariaLabel: "Mostrar destaque Economia Significativa",
  },
];
// Sub-componente para um único destaque (mantido o mesmo)
const HighlightItem = ({ icon: Icon, title, description }) => (
  <div className="flex items-center justify-center gap-3 rounded-3xl border border-[#E1E0F5] bg-white/80 px-4 py-3 text-left shadow-sm md:justify-start">
    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F2ECFF]">
      <Icon className="h-5 w-5" style={{ color: "rgb(124, 58, 237)" }} />
    </div>
    <div className="text-sm">
      <p className="font-semibold text-[#1F1B2E]">{title}</p>
      <p className="text-xs text-[#6B6790]">{description}</p>
    </div>
  </div>
);

// Componente principal
const AppHighlights = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const currentHighlight = ownerHighlightsData[activeIndex];

  return (
    <section className="border-b border-[#7C3AED]/10 bg-[#EFE9FF]">
      <div className="mx-auto w-full max-w-7xl px-4 py-3">
        {/* === Mobile View (Hidden on md and up) === */}
        <div className="md:hidden">
          {/* Cartão de destaque Mobile */}
          <div className="rounded-2xl border border-[#E1E0F5] bg-white/85 p-3 shadow-md transition-all duration-500 ease-out">
            <div className="flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F2ECFF]">
                <currentHighlight.icon
                  className="h-4 w-4"
                  style={{ color: "rgb(124, 58, 237)" }}
                />
              </div>
              <div className="text-left text-sm">
                <p className="font-semibold leading-tight text-[#1F1B2E]">
                  {currentHighlight.title}
                </p>
                <p className="text-xs text-[#6B6790]">
                  {currentHighlight.description}
                </p>
              </div>
            </div>
          </div>

          {/* Botões de navegação Mobile */}
          <div className="mt-3 flex justify-center gap-1.5">
            {ownerHighlightsData.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`h-2 w-2 rounded-full transition ${index === activeIndex ? "bg-[#7C3AED]" : "bg-[#C9C5F7]"
                  }`}
                aria-label={ownerHighlightsData[index].ariaLabel}
                onClick={() => setActiveIndex(index)}
              />
            ))}
          </div>
        </div>

        {/* === Desktop View (Grid on md and up) === */}
        <div className="hidden gap-4 md:grid md:grid-cols-3">
          {ownerHighlightsData.map((highlight, index) => (
            <HighlightItem key={index} {...highlight} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppHighlights;
